var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{staticClass:"bottom-fixed-btn"},[_c('button',{style:({
      background: ("center / cover no-repeat url('" + (_vm.data.buttonImage) + "')")
    })})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }